import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-article',
  templateUrl: './card-article.component.html',
  styleUrls: ['./card-article.component.scss'],
})
export class CardArticleComponent implements OnInit {
  @Input() item: any;
  @Input() showFavorite: boolean;
  @Input() lazySwiper: boolean;
  data: any;

  constructor() {}

  ngOnInit(): void {
    this.data = {
      id: this.item?.id,
      liked_id: this.item?.liked_content,
      favored: this.item?.liked,
      type: 'liked-news',
    };
  }

  stopPropagation(event: Event) {
    event.stopPropagation();

    return false;
  }
}
